import AntHistogram from "../../../charts/ant/AntHistogram";
import {computeLogReturns} from "../../../utils/math";


const ReturnsDistributions = ({items, itemColors})=>{

    return (
        <div style={{width: '100%'}}>
            {items.map((item, idx)=>{
                return (
                    <div style={{width: '100%', height: '300px'}}>
                        <AntHistogram data={computeLogReturns(item.chart.map(x=>x[1]))} color={itemColors[item.id]} />
                    </div>
                )
            })}
        </div>
    )
}

export default ReturnsDistributions;